module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("分享網址")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("網址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qr))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("QRCode")]), _vm._v(" "), _c('td', [_c('qr-code', {
    attrs: {
      "text": _vm.qr
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8c71a6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Share.vue
// module id = 319
// module chunks = 1